import config from 'config'
import Root from 'containers/Root'
import App from 'containers/App'
import assessorAssessment from './assessorAssessment'
import auth from './auth'

import ajs from './main/ajs'
import assessors from './main/assessors'
import awardUnits from './main/awardUnits'
import awards from './main/awards'
import leaders from './main/leaders'
import leadersOverview from './main/leadersOverview'
import misc from './main/misc'
import myNationalOffice from './main/myNationalOffice'
import myOffice from './main/myOffice'
import myOrganization from './main/myOrganization'
import myTasks from './main/myTasks'
import organizations from './main/organizations'
import organizationContacts from './main/organizationContacts'
import participants from './main/participants'
import participantsGrid from './main/participantsGrid'
import payments from './main/payments'
import registrations from './main/registrations'
import tasks from './main/tasks'
import messages from './main/messages'
import { NotFound } from 'containers/pages'
import { Redirect } from 'react-router-dom'
import React from 'react'
import awardOverview from './main/awardOverview'

const publicPath = config.publicPath

const routes = [
  {
    component: Root,
    routes: [
      {
        component: App,
        routes: [
          ...auth,
          ...assessorAssessment,

          {
            path: `${publicPath}/`,
            exact: true,
            component: () => (
              <Redirect to={`${publicPath}/participants`} />
            )
          },

          ...ajs,
          ...assessors,
          ...awardUnits,
          ...awards,
          ...leaders,
          ...leadersOverview,
          ...awardOverview,
          ...misc,
          ...myNationalOffice,
          ...myOffice,
          ...myOrganization,
          ...myTasks,
          ...organizations,
          ...organizationContacts,
          ...payments,
          ...tasks,
          ...participants,
          ...participantsGrid,
          ...registrations,
          ...messages,

          {
            component: NotFound,
            key: 'not-found'
          }
        ]
      }
    ]
  }
]

export default routes
